module.exports = __webpack_public_path__ + "static/media/1@3x.66e0581c.png";